<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Editar Perfil</div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <img v-if="previewImage" :src="previewImage" class="photo" />
                <img v-else :src="users.photo" class="photo" />
              </div>
              <div class="profile_user form-group">
                <h3 class="user_name_max">{{ users.name }}</h3>
                <hr class="hr" />
                <p style="text-align: center">{{ users.email }}</p>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userName">
                          <span class="required">*</span> Nome:
                        </label>
                        <input autocomplete="new-password" type="text" class="form-control" v-model="users.name"
                          placeholder />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">
                          <span class="required">*</span> Email:
                        </label>
                        <input autocomplete="new-password" class="form-control" id="userEmail" placeholder="" type="text"
                          v-model="users.email" />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Cellphone">Celular:</label>
                        <input class="form-control" type="text" v-mask="'(##) 99999-9999'" v-model="users.cellphone" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Phone">Telefone:</label>
                        <input autocomplete="new-password" type="text" class="form-control" v-model="users.telphone"
                          v-mask="'(##) 9999-9999'" />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCompany">
                          <span class="required">*</span> Empresa:
                        </label>
                        <select v-model="users.company_id" class="form-control">
                          <option v-for="company in companies" :value="company.id" :key="company.id">
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputDepartment">
                          <span class="required">*</span> Departamento:
                        </label>
                        <select v-model="users.department_id" class="form-control">
                          <option v-for="department in departments" :value="department.id" :key="department.id">
                            {{ department.description }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-2">
                        <label for="inputUser">
                          <span class="required">*</span> Nivel Acesso:
                        </label>
                        <select v-model="users.access_nivel" class="form-control">
                          <option :value="1" :key="1">Usuário Padrão</option>
                          <option :value="2" :key="2">Administrador</option>
                          <!-- <option v-if="$store.state.user.access_nivel == 3" :value="3" :key="3">
                            Administrador
                          </option>
                          <option v-if="$store.state.user.access_nivel == 3" :value="4" :key="4">
                            Gestor Invitee
                          </option> -->
                        </select>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label>
                          Grupos do usuário:
                        </label>
                        <v-select multiple label="title" v-model="users.users_groups" :options=users_groups></v-select>
                      </div>
                    </div>
                    <div class="form-group">
                      <b-button v-b-modal.modal-1 variant="btn btn-add">Deseja alterar a senha?</b-button>
                      <b-modal id="modal-1" hide-footer="true">
                        <div class="modal-header">
                          <label class="form-control">Digite a nova Senha</label>
                        </div>
                        <div class="modal-body">
                          <div class="col-md-12">
                            <div class="panel panel-default">
                              <div class="panel-body">
                                <div class="text-center">
                                  <div class="panel-body">
                                    <fieldset>
                                      <div class="form-group">
                                        <label for="userPassword">
                                          <span class="required">*</span>
                                          Nova Senha:
                                        </label>

                                        <input :type="fieldTypes.password" class="form-control" id="pswd" value=""
                                          v-on:keyup="verifyPassword('pswd')" v-model="users.new_password"
                                          autocomplete="new-password" />
                                      </div>
                                      <div class="form-group">
                                        <label for="userPasswordConfirmation">
                                          <span class="required">*</span>
                                          Confirmar Senha:
                                        </label>
                                        <input :type="fieldTypes.password_confirm" class="form-control" id="pswd_confirm"
                                          v-on:keyup="verifyPassword('pswd')" v-model="users.password_confirmation"
                                          placeholder autocomplete="new-password" />
                                      </div>
                                    </fieldset>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div id="message" style="margin-top: 15px">
                                          <h6>
                                            Sua senha precisa conter pelo menos
                                            um dos itens abaixo:
                                          </h6>
                                          <p id="letterpswd" class="invalid">
                                            Uma <b>letra</b> minúscula
                                          </p>
                                          <p id="capitalpswd" class="invalid">
                                            Uma <b>letra</b> maiúscula
                                          </p>
                                          <p id="numberpswd" class="invalid">
                                            Um <b>número</b>
                                          </p>
                                          <p id="lengthpswd" class="invalid">
                                            Mínimo de <b>8 caracteres</b>
                                          </p>
                                          <p id="charpswd" class="invalid">
                                            Um
                                            <b>caracter especial (@$!%*#?&-)</b>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <div class="col-md-12">
                            <div class="block text-right">
                              <b-button type="button" variant="btn btn-add" @click="hideModal" id="modal-1" :disabled="disabled &&
                                users.new_password !=
                                users.password_confirmation
                                ">
                                <i class="fa fa-save"></i> Alterar Senha
                              </b-button>
                              <span v-if="showMEssage">Senhas não conferem</span>
                            </div>
                          </div>
                        </div>
                      </b-modal>
                    </div>
                    <hr />

                    <div class="form-group">
                      <label for="userPic">Foto do Perfil</label>
                      <input type="file" id="userPic" accept="image/*" name="userPic" @change="uploadImage" placeholder />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      companies: [],
      departments: [],
      users_groups: [],
      showMEssage: false,
      fieldTypes: {
        password: "text",
        password_confirm: "text",
      },
      users: {
        name: "",
        email: "",
        cellphone: "",
        telphone: "",
        photo: "",
        access_nivel: "3",
        company_id: "",
        department_id: null,
        new_password: "",
        password_confirmation: "",
        users_groups: [],
      },
      activatedCaps: false,
      errors: undefined,
      disabled: true,

      previewImage: null,
    };
  },
  computed: {},
  methods: {
    validation() {
      let password_for = document.getElementById('pswd');
      let password_confirm = document.getElementById('pswd_confirm');

      if (password_for !== password_confirm) {
        this.showMEssage = true;
        return false;
      }
      this.showMEssage = false;
      return true;
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name);
      fd.append("email", self.users.email);
      fd.append("cellphone", self.users.cellphone);
      fd.append("telphone", self.users.telphone);
      fd.append("company_id", self.users.company_id);
      if (self.users.department_id) {
        fd.append("department_id", self.users.department_id);
      }
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("password", self.users.new_password);
      fd.append("password_confirmation", self.users.password_confirmation);

      self.users.users_groups.forEach((user_group, index) => {
        fd.append("users_groups[" + index + "]", user_group.id);
      });

      fd.append("_method", "POST");

      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }
      let validate = this.validation();
      if (validate) {
        self.$http
          .post(api, fd)
          .then((response) => {
            self.$message(
              "Sucesso",
              `Informações guardadas com sucesso`,
              "success"
            );
            this.$router.push("/users");
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }

    },
    verifyPassword(id) {
      const self = this;
      /*

    EU SEI QUE ISSO TÁ FEIO E RIDICULO, UMA HORA EU ARRUMO

    */
      if (this.users.new_password.length > 5) {
        this.fieldTypes.password = "password";
      } else {
        this.fieldTypes.password = "text";
      }

      if (this.users.password_confirmation.length > 5) {
        this.fieldTypes.password_confirm = "password";
      } else {
        this.fieldTypes.password_confirm = "text";
      }

      var myInput = document.getElementById(id);
      var letter = document.getElementById("letter" + id);
      var capital = document.getElementById("capital" + id);
      var capital = document.getElementById("capital" + id);
      var number = document.getElementById("number" + id);
      var length = document.getElementById("length" + id);
      var char = document.getElementById("char" + id);
      var count = 0;

      myInput.onkeyup = function () {
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
          letter.classList.remove("invalid");
          letter.classList.add("valid");
          letter.status = "valid";
        } else {
          letter.classList.remove("valid");
          letter.classList.add("invalid");
          letter.status = "invalid";
        }
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
          capital.classList.remove("invalid");
          capital.classList.add("valid");
          capital.status = "valid";
        } else {
          capital.classList.remove("valid");
          capital.classList.add("invalid");
          capital.status = "invalid";
        }
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
          number.classList.remove("invalid");
          number.classList.add("valid");
          number.status = "valid";
        } else {
          number.classList.remove("valid");
          number.classList.add("invalid");
          number.status = "invalid";
        }

        var chars = /[@$!%*#?&-]/g;
        if (myInput.value.match(chars)) {
          char.classList.remove("invalid");
          char.classList.add("valid");
          char.status = "valid";
        } else {
          char.classList.remove("valid");
          char.classList.add("invalid");
          char.status = "invalid";
        }

        if (myInput.value.length >= 8) {
          length.classList.remove("invalid");
          length.classList.add("valid");
          length.status = "valid";
        } else {
          length.classList.remove("valid");
          length.classList.add("invalid");
          length.status = "invalid";
        }
        if (
          number.status == "valid" &&
          letter.status == "valid" &&
          capital.status == "valid" &&
          length.status == "valid" &&
          char.status == "valid"
        ) {
          self.disabled = false;
        } else {
          self.disabled = true;
        }
      };
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.users.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.users.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.users.street = self.endereco.logradouro;
            self.users.neighborhood = self.endereco.bairro;
            self.users.state = self.endereco.uf;
            self.users.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    keymonitor() {
      if (event.getModifierState && event.getModifierState("CapsLock")) {
        this.activatedCaps = true;
      } else {
        this.activatedCaps = false;
      }
    },
    comparePassword: function () {
      if (this.users.new_password != this.users.password_confirmation || null)
        return [];
    },
    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id + "?with[]=users_groups";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          self.users.password_confirmation = "";
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsersGroups: function (id) {
      const self = this;
      const api = self.$store.state.api + "users_groups/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users_groups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    hideModal() {
      this.$bvModal.hide("modal-1");
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
  },
  mounted: function () {
    const self = this;

    self.getDepartments();
    self.getCompanies();
    let id = self.$route.params.id;
    if (id) {
      self.getUsers(id);
    }
    self.getUsersGroups();
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.uploading-image {
  display: flex;
  border-radius: 20px;
  width: 200px;
  height: 198px;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
  height: 200px;
  object-fit: cover;
}

/* .btn-put-pass:hover,
.btn-put-pass[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
} */

/* Add a green text color and a checkmark when the requirements are right */
.valid {
  color: green;
}

.valid:before {
  position: relative;
  left: 0px;
  margin-right: 5px;
  content: "✔";
}

/* Add a red text color and an "x" when the requirements are wrong */
.invalid {
  color: red;
}

.invalid:before {
  position: relative;
  left: 0px;
  margin-right: 5px;
  content: "✖";
}
</style>


// WEBPACK FOOTER //
// src/components/User/Edit.vue